module.exports = __webpack_public_path__ + "img/empty.081cf7c4.png";